import { useTranslation } from '@/lib/i18n';
import { Button } from '@/components/ui';

interface Money {
  amount: number;
  currencyCode: string;
}

export interface RefundTriggeredNoticeProps {
  refundTriggeredAt: string;
  /**
   * outbox 이벤트 UUID(내부 추적키). 호출부 데이터 계약 유지를 위해 prop 으로 받되
   * 운영자 화면에는 노출하지 않는다(T7 내부식별자 LOCK).
   */
  refundEventId?: string;
  expectedRefundAmount: Money | null | undefined;
  onDismiss: () => void;
}

const formatDateTime = (iso: string): string => {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  const pad = (n: number) => `${n}`.padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

export const RefundTriggeredNotice = ({
  refundTriggeredAt,
  expectedRefundAmount,
  onDismiss,
}: RefundTriggeredNoticeProps) => {
  const { t } = useTranslation('claims');
  const amountText = expectedRefundAmount
    ? `${expectedRefundAmount.amount.toLocaleString()} ${expectedRefundAmount.currencyCode}`
    : '-';
  return (
    <div
      role="status"
      data-testid="refund-triggered-notice"
      className="flex items-start justify-between gap-3 rounded-xl p-4"
      style={{
        background: 'var(--status-info-bg)',
        color: 'var(--status-info-fg)',
      }}
    >
      <div className="space-y-1">
        <p className="text-sm font-semibold">{t('claims.refundTriggered.title')}</p>
        <p className="text-xs">
          {t('claims.refundTriggered.body', {
            amount: amountText,
            triggeredAt: formatDateTime(refundTriggeredAt),
          })}
        </p>
        {/* refundEventId(outbox 이벤트 UUID)는 내부 추적키 — 운영자 화면 노출 금지(T7 LOCK). */}
      </div>
      <Button variant="ghost" size="sm" onClick={onDismiss}>
        {t('claims.refundTriggered.dismiss')}
      </Button>
    </div>
  );
};
